<span *ngIf="isMinMaxEqual">
  {{ minValue }}
</span>
<span *ngIf="!isMinMaxEqual">
  <span *ngIf="minValue">{{ minName | translate }} {{ minValue }}</span>
  <span *ngIf="minValue && maxValue">, </span>
  <span *ngIf="maxValue">{{ maxName | translate }} {{ maxValue }}</span>
</span>
